import React from "react";
import { Box, Typography } from "@mui/material";
import { BaseActionRendererProps, getActionData } from "./BaseActionRenderer";

interface GenericActionRendererProps extends BaseActionRendererProps {
  metadata: any;
  messageContent: string;
}

export const GenericActionRenderer: React.FC<GenericActionRendererProps> = ({ actionData, metadata, messageContent }) => {
  const actionDataTyped = getActionData(actionData);

  return (
    <Box>
      {/* Show title prominently if available */}
      {actionDataTyped.title || metadata.title ? (
        <Typography variant="body1" gutterBottom sx={{ fontWeight: 500 }}>
          {actionDataTyped.title || metadata.title}
        </Typography>
      ) : (
        <Typography variant="body2" gutterBottom>
          {messageContent}
        </Typography>
      )}

      {/* Show description if available */}
      {actionDataTyped.description && (
        <Typography variant="body2" gutterBottom sx={{ fontStyle: "italic", opacity: 0.85 }}>
          {actionDataTyped.description}
        </Typography>
      )}

      {/* Show category for priority actions */}
      {actionDataTyped.category && (
        <Typography variant="body2" gutterBottom sx={{ opacity: 0.7 }}>
          Category: {actionDataTyped.category}
        </Typography>
      )}
    </Box>
  );
};
